import React, { useState } from 'react'
import { ClickAwayListener } from '@mui/material'

export default function ClickAwayComponent({ Component }) {
  const [open, setOpen] = useState(false)

  const handleClick = () => {
    setOpen(!open)
  }

  const handleClickAway = () => {
    setOpen(false)
  }

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Component handleClick={handleClick} open={open} />
    </ClickAwayListener>
  )
}
